import { useMemo } from "react";
import { useParams } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { PublicLayout } from "@/components/layout/public-layout";
import { fetchMarketingPageDetail } from "@/lib/public-marketing";
import { MarketingBlocks } from "@/pages/public/marketing/marketing-blocks";
import { MarketingHelmet } from "@/pages/public/marketing/marketing-seo";

export function PublicMarketingDetailPage({ categoryPath }: { categoryPath: string }) {
  const { slug = "" } = useParams();

  const { data, isLoading, isError } = useQuery({
    queryKey: ["publicMarketingPageDetail", categoryPath, slug],
    queryFn: () => fetchMarketingPageDetail({ categoryPath, slug }),
    enabled: Boolean(slug),
  });

  const canonicalUrl = useMemo(() => {
    const origin = window.location.origin;
    if (!data?.canonical_path) return `${origin}/${categoryPath}/${slug}`;
    return `${origin}${data.canonical_path}`;
  }, [categoryPath, data?.canonical_path, slug]);

  return (
    <PublicLayout>
      {data ? (
        <MarketingHelmet
          title={`${data.title} · DealerDog Finance`}
          description={data.meta_description}
          ogTitle={data.meta_og_title}
          ogDescription={data.meta_og_description}
          ogImageUrl={data.meta_og_image_url}
          canonicalUrl={canonicalUrl}
        />
      ) : null}

      <section className="max-w-4xl mx-auto px-4 sm:px-6 pt-8 pb-16">
        {isLoading ? <p className="text-gray-600">Loading…</p> : null}
        {isError ? <p className="text-red-600">Not found.</p> : null}
        {data ? <MarketingBlocks blocks={data.blocks} /> : null}
      </section>
    </PublicLayout>
  );
}

